import { render } from "./DataPump.vue?vue&type=template&id=bd90fa74&ts=true"
import script from "./DataPump.vue?vue&type=script&lang=ts"
export * from "./DataPump.vue?vue&type=script&lang=ts"

import "./DataPump.vue?vue&type=style&index=0&id=bd90fa74&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__